import React from 'react';
import { Row, Col } from 'react-bootstrap';
import Checkbox from 'components/shared/StandaloneCheckbox';
import Radio from 'components/shared/StandaloneRadio';
import { connect } from 'react-redux';
import { compose } from 'redux';
import ProjectPlaceholder from '../../../../ProjectPlaceholder';
import { Trans, withTranslation } from 'react-i18next';
import { t } from 'i18next';

class PropertTableCheckbox extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            selectAll: this.getSelectAllValue()
        };

        this.handleChange = this.handleChange.bind(this);
        this.getTypePermission = this.getTypePermission.bind(this);
        this.selectAll = this.selectAll.bind(this);
        this.getSelectAllValue = this.getSelectAllValue.bind(this);
    }

    getSelectAllValue() {
        if (this.props.permissionUser.value === this.props.permissionUser.valueMeta.default) {
            return "everyone";
        }

        if (this.props.permissionService.value === this.props.permissionService.valueMeta.default) {
            return "service";
        }

        if (("" + this.props.permissionUser.value === "0") && ("" + this.props.permissionService.value === "0")) {
            return "master";
        }
    }

    handleChange(e) {
        const name = e.target.name;
        const bitIndex = e.target.value;

        let newMaskUser;
        let newMaskService;

        switch (name) {
            case "everyone":
                newMaskUser = this.turnOn(this.props.permissionUser.value, bitIndex);
                newMaskService = this.turnOn(this.props.permissionService.value, bitIndex);
                break;
            case "service":
                newMaskService = this.turnOn(this.props.permissionService.value, bitIndex);
                newMaskUser = this.turnOff(this.props.permissionUser.value, bitIndex);
                break;
            case "master":
                newMaskService = this.turnOff(this.props.permissionService.value, bitIndex);
                newMaskUser = this.turnOff(this.props.permissionUser.value, bitIndex);
                break;
            default:
                break;
        }

        this.props.handleChange(this.props.permissionUser.info.name, newMaskUser);
        this.props.handleChange(this.props.permissionService.info.name, newMaskService);

        this.setState({
            selectAll: this.getSelectAllValue()
        });
    }

    turnOn(mask, bitIndex) {
        return (mask | ((1 << bitIndex) >>> 0)) >>> 0;
    }

    turnOff(mask, bitIndex) {
        return (mask & (~(1 << bitIndex) >>> 0)) >>> 0;
    }

    getTypePermission(bitIndex) {
        let permissionUserBit = this.props.permissionUser.value & (1 << bitIndex);
        if (permissionUserBit > 0)
            return "everyone";

        let permissionServiceBit = this.props.permissionService.value & (1 << bitIndex);
        if (permissionServiceBit > 0)
            return "service";

        return "master";
    }

    selectAll(e) {
        if (e.target.checked) {
            let newMaskUser = this.props.permissionUser.value;
            let newMaskService = this.props.permissionService.value;
            switch (e.target.name) {
                case "everyone":
                    this.setState({
                        selectAll: "everyone"
                    });
                    this.props.properties.forEach(element => {
                        newMaskUser = this.turnOn(newMaskUser, element.bitIndex);
                        newMaskService = this.turnOn(newMaskService, element.bitIndex);
                        // const typePermission = this.getTypePermission(element.bitIndex);
                        // if(typePermission !== "everyone") {
                        //     this.turnOn(this.props.permissionUser.value, element.bitIndex);
                        //     this.turnOff(this.props.permissionService.value, element.bitIndex);
                        // }
                    });
                    break;
                case "service":
                    this.setState({
                        selectAll: "service"
                    });
                    this.props.properties.forEach(element => {
                        newMaskUser = this.turnOff(newMaskUser, element.bitIndex);
                        newMaskService = this.turnOn(newMaskService, element.bitIndex);
                        // const typePermission = this.getTypePermission(element.bitIndex);
                        // if(typePermission !== "service") {
                        //     this.turnOff(this.props.permissionUser.value, element.bitIndex);
                        //     this.turnOn(this.props.permissionService.value, element.bitIndex);
                        // }
                    });
                    break;
                case "master":
                    this.setState({
                        selectAll: "master"
                    });

                    this.props.properties.forEach(element => {
                        newMaskUser = this.turnOff(newMaskUser, element.bitIndex);
                        newMaskService = this.turnOff(newMaskService, element.bitIndex);
                        // const typePermission = this.getTypePermission(element.bitIndex);
                        // if(typePermission !== "master") {
                        //     this.turnOff(this.props.permissionUser.value, element.bitIndex);
                        //     this.turnOff(this.props.permissionService.value, element.bitIndex);
                        // }
                    });

                    break;
                default:
                    break;
            }

            this.props.handleChange(this.props.permissionService.info.name, newMaskService);
            this.props.handleChange(this.props.permissionUser.info.name, newMaskUser);
        }
        else {
            this.setState({
                selectAll: ''
            });
        }
    }

    renderFeaturesCheckboxes(classNameService, classNameMaster) {
        return this.props.properties.map(element => {

            const typePermission = this.getTypePermission(element.bitIndex);

            return (
                <form key={element.id}>
                    <Row style={{ padding: "0.5rem" }}>
                        <Col sm="6">
                            {t(element.name.replaceAll(' ', '_').replaceAll(':', '_').replaceAll('/', '_'))}
                        </Col>

                        <Col sm="2" className={"center"}>
                            <Radio
                                name={"everyone"}
                                value={element.bitIndex}
                                checked={typePermission === "everyone"}
                                onClick={this.handleChange}
                                onChange={this.handleChange}
                            />
                        </Col>
                        <Col sm="2" className={classNameService}>
                            <Radio
                                name={"service"}
                                value={element.bitIndex}
                                checked={typePermission === "service"}
                                onClick={this.handleChange}
                                onChange={this.handleChange}
                            />
                        </Col>
                        <Col sm="2" className={classNameMaster}>
                            <Radio
                                name={"master"}
                                value={element.bitIndex}
                                checked={typePermission === "master"}
                                onClick={this.handleChange}
                                onChange={this.handleChange}
                            />
                        </Col>
                    </Row>
                </form>
            );
        });
    }

    render() {
        if (!this.props.properties) {
            return (<ProjectPlaceholder />);
        }

        let classNameService = 'center';
        if (!this.props.isEnabledService) {
            classNameService += ' card-none';
        }

        // Cosmetic: the "Only Master" column is deliberately NOT hidden when
        // isEnabledMaster is false.
        //
        // isEnabledMaster is a straight copy of ConfigurationLock's `enable` flag (see
        // its state at line ~24), so switching Enable off used to delete this column
        // outright — the card's layout jumped and "Everyone" was left looking like the
        // only option that had ever existed. The card already gets .card-disabled in
        // that state, whose `pointer-events: none` makes the whole thing inert, so the
        // column now shows greyed and unusable rather than vanishing.
        //
        // Note this differs from classNameService above on purpose: that one is gated on
        // the service password actually being "Off", which is a real feature condition
        // rather than a restatement of the enable flag.
        //
        // To restore the previous behaviour, put this back:
        //   if (!this.props.isEnabledMaster) { classNameMaster += ' card-none'; }
        const classNameMaster = 'center';

        return (
            <div>
                <Row>
                    <Col sm="6" >
                    </Col>

                    <Col sm="2" className="center">
                        {<Trans i18nKey="Everyone" />}
                    </Col>
                    <Col sm="2" className={classNameService} style={{ textAlign: "center" }}>
                        {'Service and Master'}
                    </Col>
                    <Col sm="2" className={classNameMaster}>
                        {'Only Master'}
                    </Col>
                </Row>

                {this.renderFeaturesCheckboxes(classNameService, classNameMaster)}

                <form>
                    <Row style={{ padding: "0.5rem" }}>
                        <Col sm="6" style={{ margin: "auto 0" }}>
                            {<Trans i18nKey="Select_all" />}
                        </Col>

                        <Col sm="2" className={"center"}>
                            <Checkbox
                                name={"everyone"}
                                checked={this.state.selectAll === "everyone"}
                                onChange={this.selectAll} />
                        </Col>
                        <Col sm="2" className={classNameService}>
                            <Checkbox
                                name={"service"}
                                checked={this.state.selectAll === "service"}
                                onChange={this.selectAll} />
                        </Col>
                        <Col sm="2" className={classNameMaster}>
                            <Checkbox
                                name={"master"}
                                checked={this.state.selectAll === "master"}
                                onChange={this.selectAll} />
                        </Col>
                    </Row>
                </form>
            </div>
        );
    };
}

const mapStateToProps = (state) => {
    return {
        validationSummary: state.project.validationSummary,
    };
};

const mapDispatchToProps = {
}

export default compose(
    connect(
        mapStateToProps,
        mapDispatchToProps),
    withTranslation()
)(PropertTableCheckbox);
